function convertImageTagTotext(html = '') {
  if (!html.replace) {
    return '';
  }
  return html.replace(/<(img|image) .*?\/>/g, '【图片】');
}

function convertHtmlToText(html = '') {
  const noImageText = convertImageTagTotext(html || '');
  const tmp = document.implementation.createHTMLDocument('new').body;
  tmp.innerHTML = noImageText;
  return tmp.textContent || tmp.innerText || '';
}

export default convertHtmlToText;
